export default __webpack_public_path__ + "assets/images/c0f776cb920ac9a00adf2c443a3722a8.webp";